// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniCartStyles } from "@synd/App/Components/MiniCart/MiniCart";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, styledScrollbar, createLinkIconStyles } from "@synd/XDL/Utilities";
import Trash2 from "@insite/mobius/Icons/Trash2";
import { css } from "styled-components";

miniCartStyles.loadingOverlay = {
    css: css`
        height: 100%;
        width: 100%;
    `,
};
miniCartStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
    `,
};
miniCartStyles.centerWrapper = {
    css: css`
        display: flex;
        flex: 1;
        padding: 16px;
        width: 100%;
        flex-direction: column;
        gap: 8px;
        span {
            height: fit-content;
        }
    `,
};
miniCartStyles.minicartFooterContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        padding: 16px;
        border-top: 1px solid ${color("common.border")};
    `,
};
miniCartStyles.summarySectionWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        margin-right: 4px;
    `,
};

miniCartStyles.infoWrapper = {
    css: css`
        display: flex;
        gap: 4px;
        flex-wrap: nowrap;
        width: 140px;
    `,
};

miniCartStyles.countLabel = {
    ...fontConfig.small,
};

miniCartStyles.countValue = {
    ...fontConfig.smallSingleLine,
    weight: fontConfig.weight.bold,
};

miniCartStyles.subTotalLabel = {
    ...fontConfig.small,
};

miniCartStyles.subTotalValue = {
    ...fontConfig.smallSingleLine,
    weight: fontConfig.weight.bold,
};

miniCartStyles.cartLinesWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 16px 0 16px 16px;
        gap: 8px;
        margin-right: 4px;
        ${styledScrollbar({ width: 4 })}
        & > div:not(:last-child) {
            padding-bottom: 8px;
            border-bottom: 1px solid ${color("common.border")};
        }
        max-height: calc(100vh - 200px);
    `,
};

miniCartStyles.fancyScroll = {
    css: css`
        height: 100%;
    `,
};

miniCartStyles.actionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-top: 12px;
        gap: 12px;
    `,
};

miniCartStyles.clearCartWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        padding: 4px 16px 12px 16px;
        background: ${color("common.ui8")};
    `,
};

miniCartStyles.clearCartButton = {
    ...createLinkIconStyles({
        icon: Trash2,
        sizeVariant: "xsmall",
        variant: "primary",
        linkStyles: {
            icon: {
                iconProps: {
                    size: 12,
                },
            },
        },
    }),
};
